import { render } from "./Trademarks.vue?vue&type=template&id=14e519a2&scoped=true"
import script from "./Trademarks.vue?vue&type=script&lang=js"
export * from "./Trademarks.vue?vue&type=script&lang=js"

import "./Trademarks.vue?vue&type=style&index=0&id=14e519a2&scoped=true&lang=css"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e519a2"]])

export default __exports__